import PricingAndRisk from './sections/pricing-and-risk';
import PricingInfo from './sections/pricing-info';
import PricingData from './sections/pricing-market-data';
import PricingDataAnalytics from './sections/pricing-market-data-analytics';
import PricingModel from './sections/pricing-model';
import PricingTrades from './sections/pricing-trades';
import RiskLadder from './sections/risk-ladder';
import './styles.scss';

const Pricing = () => {
  return (
    <div className="pricing-container">
      <PricingInfo />

      <div className="pricing-tab">
        <PricingTrades />
        <PricingAndRisk />
        <PricingData />
        <PricingDataAnalytics />
        <PricingModel />
        <RiskLadder />
      </div>
    </div>
  );
};

export default Pricing;
